module.exports = __webpack_public_path__ + "img/1506949913.6f8ff3f8.jpg";